import { FC, useState } from 'react';
import Button from '@/components/controls/Button/Button.component';
import buttonStyles from '@/components/controls/Button/Button.module.scss';
import WebCamModal from '@/components/interactive/WebCamSourceBlock/WebCamModal/WebCamModal.component';
import { WebCamSourceBlockPropsIF } from '@/components/interactive/WebCamSourceBlock/WebCamSourceBlock.types';

const WebCamSourceBlock: FC<WebCamSourceBlockPropsIF> = ({
    addFiles,
    className,
    isDisabled,
    children,
    buttonVariant,
}) => {
    const [isWebcamOpen, setIsWebcamOpen] = useState<boolean>(false);

    const variantClassName = buttonVariant
        ? `${buttonStyles.button} ${buttonStyles[buttonVariant]}`
        : '';

    const addFilesHandler = (files: File[]): void => {
        addFiles(files);
        setIsWebcamOpen(false);
    };

    return (
        <>
            <Button
                className={`${className} ${variantClassName}`}
                isCustom
                clickHandler={() => setIsWebcamOpen(true)}
                dataTest="open_webcam_button"
                disabled={isDisabled}
            >
                {children}
            </Button>
            {isWebcamOpen && (
                <WebCamModal
                    addFiles={addFilesHandler}
                    onClose={() => setIsWebcamOpen(false)}
                />
            )}
        </>
    );
};

export default WebCamSourceBlock;
